import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  confirmDialogRef: MatDialogRef<ConfirmDialogComponent> | undefined;

  constructor(private dialog: MatDialog) {}

  public openConfirm(options: any) {
    this.confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      minWidth: '33%',
      maxWidth: '60%',
      data: {
        title: options.title,
        warning:
          options.warning === null || options.warning === undefined
            ? null
            : options.warning,
        message: options.message,
        cancelText: options.cancelText,
        confirmText: options.confirmText,
      },
    });
    return this.confirmDialogRef;
  }

  public confirmed(): Observable<any> | undefined {
    return this.confirmDialogRef?.afterClosed().pipe(
      take(1),
      map((res) => res)
    );
  }
}
